import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, concatMap, exhaustMap, map, of, tap } from "rxjs";
import { ConditionalService } from "src/app/shared/services/conditional.service";
import { ConditionalActions } from "./condicional.actions";
import { NotifyService } from "src/app/shared/services/notify.service";

@Injectable()

export class CondicionalEffects {

    constructor(
        private service: ConditionalService,
        private action$: Actions,
        private notify: NotifyService
    ) { }

    loadRelease$ = createEffect(() =>
        this.action$.pipe(
            ofType(ConditionalActions.loadRelease),
            exhaustMap(({ id }) =>
                this.service
                    .getRelease(id)
                    .pipe(
                        map((res) => ConditionalActions.loadReleaseSuccess({ release: res })),
                        catchError((error) => {
                            this.notify.emitError('Falha ao carregar registros')
                            return of(error.error['hydra:description'])
                        })
                    )

            )
        )
    )

    loadTrigger$ = createEffect(() =>
        this.action$.pipe(
            ofType(ConditionalActions.loadTrigger),
            exhaustMap(({ id }) =>
                this.service
                    .getTrigger(id)
                    .pipe(
                        map((res) => ConditionalActions.loadTriggerSuccess({ trigger: res })),
                        catchError((error) => {
                            this.notify.emitError('Falha ao carregar registros')
                            return of(error.error['hydra:description'])
                        })
                    )

            )
        )
    )

    editRelease$ = createEffect(() =>
        this.action$.pipe(
            ofType(ConditionalActions.editRelease),
            concatMap(
                ({ release, id }) =>
                    this.service
                        .editRelease(release, id)
                        .pipe(
                            tap(() => this.notify.editSuccess()),
                            map((res) => ConditionalActions.loadRelease({ id: res.clientId })),
                            catchError((error) => {
                                this.notify.emitError(error.error['hydra:description'])
                                return of(error.error['hydra:description']);
                            })
                        )
            )
        )
    );

    editTrigger$ = createEffect(() =>
        this.action$.pipe(
            ofType(ConditionalActions.editTrigger),
            concatMap(
                ({ trigger, id }) =>
                    this.service
                        .editTrigger(trigger, id)
                        .pipe(
                            tap(() => this.notify.editSuccess()),
                            map((res) => ConditionalActions.loadTrigger({ id: res.clientId })),
                            catchError((error) => {
                                this.notify.emitError(error.error['hydra:description'])
                                return of(error.error['hydra:description']);
                            })
                        )
            )
        )
    );
}